import {lazy} from '@aboutyou/lazy-imports';
import {LoadingPageSpinner} from '@aboutyou/ui-components';
import React from 'react';

export const OrderDetailPage = lazy(
  () =>
    import('./OrderDetailPage.eager').then(mod => ({
      default: mod.OrderDetailPage,
    })),
  {
    fallback: <LoadingPageSpinner />,
    aboveTheFold: true,
    isSsrAndNeedsHydration: true,
  },
);
